import { SystemLocale } from '@ninja/utilities';
import { CustomerWebSiteAppInitResponse } from '@shory-health-individual/customer-api';
import { UserAcknowledgementType } from '../common';
import { getAppInitServerData } from './get-app-init-server-data';

class AppInit {
	data: CustomerWebSiteAppInitResponse;

	constructor(locale: SystemLocale) {
		const appInit = getAppInitServerData(locale);

		this.data = appInit;
	}

	public getBenefitCategoryById = (benefitCatId: number) =>
		this.data.benefitCategories?.find((b) => b.id === benefitCatId);

	public getBenefitById = (benefitId: number) => this.data.benefits?.find((b) => b.id === benefitId);

	public getCountryById = (countryId: number) => this.data.countries?.find((c) => c.id === countryId);

	public getCurrencyById = (currencyId: number) => this.data.currencies?.find((c) => c.id === currencyId);

	public getEmirateById = (emirateId: number) => this.data.emirates?.find((e) => e.id === emirateId);

	public getFacilityById = (facilityTypeId: number) => this.data.facilityTypes?.find((f) => f.id === facilityTypeId);

	public getGenderById = (genderId: number) => this.data.genders?.find((g) => g.id === genderId);

	public getInsuranceCompanyById = (icId: number) => this.data.insuranceCompanies?.find((g) => g.id === icId);

	public getMaritalStatusById = (maritalStatueId: number) =>
		this.data.maritalStatuses?.find((m) => m.id === maritalStatueId);

	public getNetworkById = (networkGroupId: number) => this.data.networkGroups?.find((b) => b.id === networkGroupId);

	public getPaymentConfigByKey = (paymentKey: string) => this.data.paymentConfig?.find((p) => p.key === paymentKey);

	public getDocumentUploadSize = () => this.data.systemConfigurationSettings?.uploadDocumentMaxSizeInKB;

	public getPlanExclusionsById = (planExclusionId: number) =>
		this.data.planExclusions?.find((p) => p.id === planExclusionId);

	public getPlanById = (planId: number) => this.data.plans?.find((p) => p.id === planId);

	public getPlanTypeById = (planTypeId: number) => this.data.planTypes?.find((p) => p.id === planTypeId);

	public getRelationshipById = (relationshipTypeId: number) =>
		this.data.relationships?.find((r) => r.id === relationshipTypeId);

	public getSalaryBandById = (salaryBandId: number) => this.data.salaryBands?.find((r) => r.id === salaryBandId);

	public getUserAcknowledgementsByTypeName = (userAcknowledgementType: UserAcknowledgementType) => {
		const acknowledgementTypeId = this.data.userAcknowledgementTypes?.find(
			(t) => t.name === userAcknowledgementType
		)?.id;

		return this.data.userAcknowledgements?.find((u) => u.userAcknowledgementTypeId === acknowledgementTypeId);
	};

	public getVatConfigById = (vatConfigId: number) => this.data.vatConfigurations?.find((e) => e.id === vatConfigId);

	public getPolicyTypesById = (policyTypeId: number) => this.data.policyTypes?.find((e) => e.id === policyTypeId);

	public getOccupationById = (occupationId?: number) => this.data.occupations?.find((e) => e.id === occupationId);
}

export default AppInit;
